import { useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import useFetchDataForWidgets from 'src/Libs/dashboard-widgets/hooks/use-fetch-data-for-widgets'
import { useDynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-provider'
import BatteryWidget from './widgets/BatteryWidget'
import { useWallboxWidgets } from './widgets/wallbox/WallboxWidgets'
import PvForecastWidget from './widgets/PvForecastWidget/PvForecastWidget'
import WidgetsSkeleton from './WidgetsSkeleton'
import { WidgetAreasConfiguration } from '../dashboard/types'
import DynamicPowerPriceWidgetContainer from './widgets/dynamic-power-price/DynamicPowerPriceWidgetContainer'
import DashboardWidgetContainer from './ResponsiveContainer'

type Props = {
  installationId?: string
  storageId?: string
  hide: boolean
  widgetsConfiguration: WidgetAreasConfiguration
}

/*
 * A component that renders the widgets on the dashboard.
 */
const DashboardWidgets: React.FC<Props> = ({ installationId, storageId, hide, widgetsConfiguration }) => {
  const theme = useTheme()
  const { isDynamicPowerPriceEnabled, isDynamicPowerPriceLoading } = useDynamicPowerPricesEnabledContext()
  const {
    amountOfWidgetsToBeDisplayed,
    isWidgetDataLoading,
    pvForecastWidgetData,
    dynamicPowerPriceWidgetData,
    batteryWidgetData,
    wallboxWidgetsData,
  } = useFetchDataForWidgets({
    installationId,
    storageId,
  })
  const activateDashboardConfiguration = useMediaQuery(theme.breakpoints.down('md'))
  const hidePvForecast = activateDashboardConfiguration ? widgetsConfiguration.weatherForecast.hidden : false
  const hideDynamicPowerPrice = (activateDashboardConfiguration && widgetsConfiguration.priceHistory.hidden) || !isDynamicPowerPriceEnabled
  const hideBattery = activateDashboardConfiguration && widgetsConfiguration.battery.hidden
  const hideWallbox = activateDashboardConfiguration && widgetsConfiguration.garage.hidden
  const wallboxWidgets = useWallboxWidgets({ ...wallboxWidgetsData, hide: hideWallbox })

  if (hide) return null
  if (isWidgetDataLoading || isDynamicPowerPriceLoading) return <WidgetsSkeleton amountOfWidgets={amountOfWidgetsToBeDisplayed} />

  return (
    <DashboardWidgetContainer>
      {!hideBattery && <BatteryWidget {...batteryWidgetData} />}

      {...wallboxWidgets}

      {!hideDynamicPowerPrice && <DynamicPowerPriceWidgetContainer {...dynamicPowerPriceWidgetData} />}

      {!hidePvForecast && <PvForecastWidget {...pvForecastWidgetData} />}
    </DashboardWidgetContainer>
  )
}

export default DashboardWidgets
